import { render } from "./AboutUsSection.vue?vue&type=template&id=77a2b4be&scoped=true"
import script from "./AboutUsSection.vue?vue&type=script&lang=js"
export * from "./AboutUsSection.vue?vue&type=script&lang=js"

import "./AboutUsSection.vue?vue&type=style&index=0&id=77a2b4be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a2b4be"]])

export default __exports__